import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { IPropertyBag } from 'app/extensibility/property-bag';
import { calcExpressionString, isExpressionString } from 'app/extensibility/utils/expression.util';

export type ConnectionRoleType = 'source' | 'sink' | 'staging' | 'controlTable';

export function isTableNameRequired(datasetConfig: IDatasetTypeMetadata, entity: IPropertyBag): boolean {
    return datasetConfig?.isTableNameRequired ? (
        isExpressionString(datasetConfig.isTableNameRequired) ?
            calcExpressionString(datasetConfig.isTableNameRequired, entity) :
            datasetConfig.isTableNameRequired
    ) : false;
}

export function notSupportCopySourceQuery(datasetConfig: IDatasetTypeMetadata, entity: IPropertyBag): boolean {
    return datasetConfig?.notSupportCopySourceQuery ? (
        isExpressionString(datasetConfig.notSupportCopySourceQuery) ?
            calcExpressionString(datasetConfig.notSupportCopySourceQuery, entity) :
            datasetConfig.notSupportCopySourceQuery
    ) : false;
}

export function supportEditPhysicalType(datasetConfig: IDatasetTypeMetadata, entity: IPropertyBag): boolean {
    return isExpressionString(datasetConfig?.supportEditPhysicalType) && entity ?
        calcExpressionString(datasetConfig.supportEditPhysicalType, entity) :
        datasetConfig?.supportEditPhysicalType === true;
}

export function supportAutoTableCreation(datasetConfig: IDatasetTypeMetadata, entity: IPropertyBag): boolean {
    return isExpressionString(datasetConfig?.supportAutoTableCreation) && entity ?
        calcExpressionString(datasetConfig.supportAutoTableCreation, entity) :
        datasetConfig?.supportAutoTableCreation === true;
}

export function isSplitTablePath(datasetConfig: IDatasetTypeMetadata, entity: IPropertyBag): boolean {
    if (isExpressionString(datasetConfig?.splitTablePath) && entity) {
        return calcExpressionString(datasetConfig.splitTablePath, entity);
    }
    
    // For boolean values, check if it's true
    if (datasetConfig?.splitTablePath === true) {
        // For HubSpot, additionally check if linked service is v2
        if (datasetConfig.type === 'HubspotObject' && entity?.linkedService) {
            return entity.linkedService.version === 'v2';
        }
        return true;
    }
    
    return false;
}
